import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

type Size = 'sm' | 'md' | 'full';

type Props = {
  size?: Size;
  children?: React.ReactNode;
  className?: string;
};

const containerClasses: Record<Size, string> = {
  sm: 'sm:max-w-xl',
  md: 'md:max-w-3xl',
  full: 'max-w-none',
};

// @TODO(juan): Replace all Container with the new ContentContainer component

/**
 * @deprecated note(juan): try to avoid using this for new content
 * Specially if you need to use the <Container/> component and manually add styles to it using the className prop
 *
 * Prefer using <ContentContainer/>
 */
export const Container = ({ size = 'md', className, children }: Props): JSX.Element => {
  return (
    <div
      className={twMerge(cx(containerClasses[size], 'container pt-40 pb-20 px-24 sm-d:pt-24 md:px-[108px]', className))}
    >
      {children}
    </div>
  );
};
